import { useContext } from "react";
import { AuthContext } from "../components/contexts/AuthProvider";

const useAuth = () => {
  return useContext(AuthContext);
};

export default useAuth;
